import React from 'react'

import {Link} from 'react-router-dom'
export default function Show() {
  return (
    
    <div className="show">
        <h2 className="main-title">Get Leatest Update By Subscribe
</h2>
<h2 className="main-title">
0ur Newslater</h2>
<Link to='/page'>
<button className="btn1">Shop Now</button>
</Link>
    </div>
  )
}
